/**
 * global runtime constants for the plugin
 */
export const Const = {
    ////////////////////////// globals ////////////////////////////
    STORE_MODULE_NAME: "vue-provider-cache",
    REF: 'vpc',
    /**
     * router config for the remote
     * blockmaze-price-feed-microservice host
     */
    WS_PRICE_FEED_DOMAIN: {
        // HOST: 'https://dev.finvasia.com:5000', //to access locally 
        // HOST: 'https://wtpricefeed.sysfx.com', //to access Live 
        // HOST: 'https://82.221.128.46:5002',
        // HOST: process.env.PRICE_FEED_URL,
        // HOST: "https://demofeed.coinexx.com",
        HOST: process.env.PRICE_FEED_URL,
        // HOST: 'https://demofeed.coinexx.com',
        // HOST: 'https://90.32.1.159:5002',
        // HOST:'https://feed.fxview.com',
        // HOST: 'https://pricefeed.fxview.com:2087',
        // HOST: 'https://localhost:5000',
        //HOST: 'https://50.28.50.136:5000', 
        //HOST: 'https://turnkeyforex.com:5000', 
        EP_API_SEARCH_BY: '/api/ws-price-feed/search-by',
        EP_API_CONFIG: '/api/ws-price-feed/config'
    },
    ////////////////////////// actions ////////////////////////////
    // load global config 
    RUN_REGISTER_PROVIDERS: 'vue-provider-cache/vpc' + '/RUN_REGISTER_PROVIDERS',
    // run heartbeat for s single cachetag 
    RUN_HERARTBEAT: 'vue-provider-cache/vpc' + '/RUN_HERARTBEAT',
    //////////////////// mutations //////////////////////////////
    // start and register providers
    SET_REGISTER_PROVIDERS: 'vue-provider-cache/vpc' + '/SET_REGISTER_PROVIDERS',
    // update heartbeat for single provider
    SET_HEARTBEAT: 'vue-provider-cache/vpc' + '/SET_HEARTBEAT',
    //////////////////// getters //////////////////////////////
    // get heartbeats from all providers
    GET_HEARTBEATS: 'vue-provider-cache/vpc' + '/GET_HEARTBEATS',
    // get all providers
    GET_PROVIDERS: 'vue-provider-cache/vpc' + '/GET_PROVIDERS'
};
export const ConstCache = {
    ////////////////////////// globals ////////////////////////////
    STORE_MODULE_NAME: "vue-provider-cache",
    REF: 'vpc',
    /**
     * router config for the remote
     * blockmaze-price-feed-microservice host
     */
    WS_PRICE_FEED_DOMAIN: {
        HOST: 'https://dev.finvasia.com:5000',
        // HOST: 'https://pricefeed.fxview.com:2087', 
        // HOST: 'https://localhost:5000',
        //HOST: 'https://50.28.50.136:5000', 
        //HOST: 'https://turnkeyforex.com:5000', 
        EP_API_SEARCH_BY: '/api/ws-price-feed/search-by',
        EP_API_CONFIG: '/api/ws-price-feed/config'
    },
    ////////////////////////// actions ////////////////////////////
    // load global config 
    RUN_REGISTER_PROVIDERS: 'vue-provider-cache/vpc' + '/RUN_REGISTER_PROVIDERS',
    // run heartbeat for s single cachetag 
    RUN_HERARTBEAT: 'vue-provider-cache/vpc' + '/RUN_HERARTBEAT',
    //////////////////// mutations //////////////////////////////
    // start and register providers
    SET_REGISTER_PROVIDERS: 'vue-provider-cache/vpc' + '/SET_REGISTER_PROVIDERS',
    // update heartbeat for single provider
    SET_HEARTBEAT: 'vue-provider-cache/vpc' + '/SET_HEARTBEAT',
    //////////////////// getters //////////////////////////////
    // get heartbeats from all providers
    GET_HEARTBEATS: 'vue-provider-cache/vpc' + '/GET_HEARTBEATS',
    // get all providers
    GET_PROVIDERS: 'vue-provider-cache/vpc' + '/GET_PROVIDERS'
};



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/const.mod.ts
// module id = 3I5z
// module chunks = 4